import { animate, animateChild, group, keyframes, query, state, style, transition, trigger } from '@angular/animations';
import { CdkPortalOutlet, Portal } from '@angular/cdk/portal';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { TUTORIAL_BUTTON_DATA } from '../tutorial-button-ref';

const ANIMATION_TIMING_FUNCTION = 'cubic-bezier(0.4, 0.0, 0.2, 1)';

@Component({
  selector: 'mandae-tutorial-button',
  templateUrl: './tutorial-button.component.html',
  styleUrls: ['./tutorial-button.component.scss'],
  animations: [
    trigger('state', [
      state('open', style({
        backgroundColor: '#FAFAFA',
        color: '#4A4A4A',
        boxShadow: '0 7px 8px -4px rgba(0,0,0,.2),0 12px 17px 2px rgba(0,0,0,.14),0 5px 22px 4px rgba(0,0,0,.12)',
        width: '350px',
        borderRadius: '4px',
      })),
      state('close', style({
        backgroundColor: '#FF6900',
        color: '#FFFFFF',
        boxShadow: '0 2px 4px -1px rgba(0,0,0,.2),0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12)',
        width: '*',
        borderRadius: '21px',
      })),
      transition('open => close', group([
        query('div', animateChild()),
        animate(`200ms ${ANIMATION_TIMING_FUNCTION}`, keyframes([
          style({
            width: '350px',
            minHeight: '250px',
            height: '*',
            color: '#4A4A4A',
            backgroundColor: '#FAFAFA',
            boxShadow: '0 7px 8px -4px rgba(0,0,0,.2),0 12px 17px 2px rgba(0,0,0,.14),0 5px 22px 4px rgba(0,0,0,.12)',
            borderRadius: '4px',
            offset: 0,
          }),
          style({
            width: '225px',
            minHeight: '52px',
            height: '52px',
            color: '#FFFFFF',
            backgroundColor: '#FF6900',
            boxShadow: '0 3px 5px -1px rgba(0,0,0,.2),0 6px 10px 0 rgba(0,0,0,.14),0 1px 18px 0 rgba(0,0,0,.12)',
            borderRadius: '12px',
            offset: 0.6,
          }),
          style({
            width: '*',
            minHeight: '0px',
            height: '*',
            color: '#FFFFFF',
            backgroundColor: '#FF6900',
            boxShadow: '0 2px 4px -1px rgba(0,0,0,.2),0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12)',
            borderRadius: '20px',
            offset: 1,
          }),
        ]))
      ])),
      transition('close => open', group([
        query('div', animateChild()),
        animate(`250ms ${ANIMATION_TIMING_FUNCTION}`, keyframes([
          style({
            width: '100px',
            minHeight: '0px',
            height: '36px',
            color: '#FFFFFF',
            backgroundColor: '#FF6900',
            // mat-elevation-z4
            boxShadow: '0 2px 4px -1px rgba(0,0,0,.2),0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12)',
            borderRadius: '20px',
            offset: 0,
          }),
          style({
            width: '225px',
            minHeight: '52px',
            height: '52px',
            color: '#FFFFFF',
            backgroundColor: '#FF6900',
            // mat-elevation-z6
            boxShadow: '0 3px 5px -1px rgba(0,0,0,.2),0 6px 10px 0 rgba(0,0,0,.14),0 1px 18px 0 rgba(0,0,0,.12)',
            borderRadius: '12px',
            offset: 0.4,
          }),
          style({
            width: '350px',
            minHeight: '200px',
            height: '*',
            color: '#4A4A4A',
            backgroundColor: '#FAFAFA',
            // mat-elevation-z12
            boxShadow: '0 7px 8px -4px rgba(0,0,0,.2),0 12px 17px 2px rgba(0,0,0,.14),0 5px 22px 4px rgba(0,0,0,.12)',
            borderRadius: '4px',
            offset: 1,
          }),
        ])),
      ])),
    ])
  ],
})
export class TutorialButtonComponent implements OnInit {

  public contentPortal: Portal<any>;

  @ViewChild(CdkPortalOutlet)
  public contentOutlet: CdkPortalOutlet;

  public get panelClass() {
    return {
      'tutorial-button': true,
      'panel-closed': !this.panelOpen,
      'panel-open': this.panelOpen,
    };
  }

  private _panelOpen = false;
  public get panelOpen() {
    return this._panelOpen;
  }
  public set panelOpen(value: boolean) {
    this._panelOpen = value;
  }

  constructor(@Inject(TUTORIAL_BUTTON_DATA) public buttonLabel: string) { }

  ngOnInit() {
  }

  togglePanel() {
    this.panelOpen = !this.panelOpen;
  }

}
